import "babel-polyfill";
import "slick-carousel";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder, fwa} from "./libs/binder";
import {
    staticFunctions,
    constants,
    commonFunction,
    anotherCommonFunction,
    navFunction,
    myUnusedFunction
} from "./modules/module";
import {accordion} from "./modules/accordion";
import {accordionServices} from "./modules/accordion-services";
import {header} from "./modules/header";
import {footer} from "./modules/footer";
import {mobileNav} from "./modules/mobileNav";
import {headerSearch} from "./modules/headerSearch";
import {capabilitiesSlider} from "./modules/capabilities-slider";
import {testimonialsSlider} from "./modules/testimonials-slider";
import {newsSlider} from "./modules/news-slider";
import {gallerySlider} from "./modules/gallery-slider";
import {gallerySlider2} from "./modules/gallery-slider2";
import {scrollBtn} from "./modules/scrollBtn";
import {backgroundParallax} from "./modules/background-parallax";
import {ticker} from "./modules/ticker";
import {faqSearch} from "./modules/faq-search";
import {tabs} from "./modules/tabs";
import {ourStorySlider} from "./modules/our-story-slider";
import {anchors} from "./modules/anchors";
import {stepsProgress} from "./modules/stepsProgress";
import {productsSlider} from "./modules/products-slider";
import {popups} from "./modules/popups";
import {cascadeImageSlider} from "./modules/cascade-image-slider";
import {customSelect} from "./modules/customSelect";
import {filtersReset} from "./modules/filtersReset";


binder({
    bounds: {
        "html": [constants, staticFunctions],
        "body": [commonFunction, anotherCommonFunction],
        ".header": [header, mobileNav, headerSearch],
        ".footer": footer,
        ".accordion": accordion,
        ".js-accordion-services": accordionServices,
        ".js-capabilities-slider": capabilitiesSlider,
        ".js-testimonials-slider": testimonialsSlider,
        ".js-news-slider": newsSlider,
        ".js-gallery-slider": gallerySlider,
        ".js-gallery-slider2": gallerySlider2,
        ".scrollToTopBtn": scrollBtn,
        ".subscribe": backgroundParallax,
        ".section-ticker,.our-partners-list": ticker,
        ".faq-area": faqSearch,
        ".tabs": tabs,
        ".our-story-slider": ourStorySlider,
        ".has-anchor, .page-nav-holder a": anchors,
        ".section-difference .steps-list": stepsProgress,
        ".products-list.has-slider": productsSlider,
        ".popup-link": popups,
        ".cascade-image-slider": cascadeImageSlider,
        ".custom-select": customSelect,
        ".form-filters": filtersReset,
    },
    runTests: false
});





// WEBPACK FOOTER //
// ./assets/js/global.js